import common from './common.json';
import globalNavigation from './globalNavigation.json';
import userProfileMenu from './userProfileMenu.json';
import downloadMobileAppModal from './downloadMobileAppModal.json';
import peopleProfileSidebar from './peopleProfileSidebar.json';
import days from './days.json';

export const de = {
  common,
  globalNavigation,
  userProfileMenu,
  downloadMobileAppModal,
  peopleProfileSidebar,
  days,
};
